/**
 * 新版 UI 公共指令：元素进入视口时添加 .gx-rv-in 触发动画
 * 用法：v-reveal 或 v-reveal="{ threshold: 0.1 }"
 */
export const revealDirective = {
  inserted(el, binding) {
    el.classList.add('gx-rv')
    const threshold = (binding.value && binding.value.threshold) || 0.08
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.classList.add('gx-rv-in')
            obs.disconnect()
          }
        })
      },
      { threshold }
    )
    obs.observe(el)
    el._gxObs = obs
  },
  unbind(el) {
    if (el._gxObs) {
      el._gxObs.disconnect()
      el._gxObs = null
    }
  }
}

export default {
  install(Vue) {
    Vue.directive('reveal', revealDirective)
  }
}
